import PasswordGate from '../components/PasswordGate';
import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import api from '../services/api';

const PM = ['Deema','Taly'];

function printStores(stores) {
  const win = window.open('', '_blank');
  const rows = stores.map(s=>'<tr><td style="font-weight:600">'+s.store_name+'</td><td><span style="background:#fef3c7;color:#92400e;padding:2px 10px;border-radius:12px;font-size:12px;font-weight:600">'+parseFloat(s.percentage).toFixed(1)+'%</span></td><td>'+s.payment_method+'</td><td>'+(s.notes||'--')+'</td></tr>').join('');
  win.document.write('<!DOCTYPE html><html><head><title>Takhier Stores</title><style>body{font-family:Arial,sans-serif;padding:30px;color:#111}.header{display:flex;justify-content:space-between;border-bottom:2px solid #00b368;padding-bottom:16px;margin-bottom:20px}.company{font-size:22px;font-weight:700;color:#00b368}table{width:100%;border-collapse:collapse;font-size:13px}th{background:#f5f5f5;padding:10px 12px;text-align:left;font-size:11px;text-transform:uppercase;border-bottom:2px solid #eee;color:#666}td{padding:10px 12px;border-bottom:1px solid #f0f0f0}.footer{margin-top:30px;text-align:center;font-size:11px;color:#aaa;border-top:1px solid #eee;padding-top:12px}</style></head><body><div class="header"><div><img src="https://teknulugy.online/logo.svg" style="height:38px;width:auto" alt="Teknulugy"/><div style="font-size:12px;color:#666">Takhier - Stores Report</div></div><div style="text-align:right"><div style="font-size:18px;font-weight:700">Stores Report</div><div style="font-size:12px;color:#666">Generated: '+new Date().toLocaleDateString()+'</div><div style="font-size:12px;color:#666">Total Stores: '+stores.length+'</div></div></div><table><thead><tr><th>Store Name</th><th>Commission %</th><th>Payment Method</th><th>Notes</th></tr></thead><tbody>'+rows+'</tbody></table><div class="footer">Teknulugy IT Services - Ahmed Al Jaber Street, Baitak Tower, Floor 1, Office D - +965 55107000</div></body></html>');
  win.document.close();
  setTimeout(()=>win.print(),500);
}

function printTransactions(txns, totalAmount, totalCommission, totalNet) {
  const win = window.open('', '_blank');
  const rows = txns.map(t=>'<tr><td>'+t.transaction_date+'</td><td style="font-weight:600">'+(t.store?.store_name||'--')+'</td><td style="font-family:monospace">'+(t.order_id||'--')+'</td><td style="font-family:monospace">'+(t.merchant_id||'--')+'</td><td>'+t.payment_method+'</td><td style="font-weight:600">KWD '+parseFloat(t.amount).toFixed(3)+'</td><td style="color:#166534;font-weight:700">KWD '+parseFloat(t.commission).toFixed(3)+' ('+parseFloat(t.percentage).toFixed(1)+'%)</td><td style="color:#555">KWD '+parseFloat(t.net_profit).toFixed(3)+'</td></tr>').join('');
  win.document.write('<!DOCTYPE html><html><head><title>Takhier Transactions</title><style>body{font-family:Arial,sans-serif;padding:30px;color:#111}.header{display:flex;justify-content:space-between;border-bottom:2px solid #00b368;padding-bottom:16px;margin-bottom:20px}.company{font-size:22px;font-weight:700;color:#00b368}.stats{display:flex;gap:20px;margin-bottom:20px}.stat{background:#f5f5f5;padding:12px 20px;border-radius:8px}.stat-label{font-size:11px;color:#888}.stat-val{font-size:16px;font-weight:700;margin-top:2px}table{width:100%;border-collapse:collapse;font-size:12px}th{background:#f5f5f5;padding:9px 10px;text-align:left;font-size:10px;text-transform:uppercase;border-bottom:2px solid #eee;color:#666}td{padding:9px 10px;border-bottom:1px solid #f0f0f0}.total-row{font-weight:700;background:#f0fdf4}.footer{margin-top:30px;text-align:center;font-size:11px;color:#aaa;border-top:1px solid #eee;padding-top:12px}</style></head><body><div class="header"><div><img src="https://teknulugy.online/logo.svg" style="height:38px;width:auto" alt="Teknulugy"/><div style="font-size:12px;color:#666">Takhier - Transactions Report</div></div><div style="text-align:right"><div style="font-size:18px;font-weight:700">Transactions Report</div><div style="font-size:12px;color:#666">Generated: '+new Date().toLocaleDateString()+'</div></div></div><div class="stats"><div class="stat"><div class="stat-label">Total Amount</div><div class="stat-val">KWD '+totalAmount.toFixed(3)+'</div></div><div class="stat"><div class="stat-label">Teknulugy Profit</div><div class="stat-val" style="color:#166534">KWD '+totalCommission.toFixed(3)+'</div></div><div class="stat"><div class="stat-label">Net to Store</div><div class="stat-val">KWD '+totalNet.toFixed(3)+'</div></div></div><table><thead><tr><th>Date</th><th>Store</th><th>Order ID</th><th>Merchant ID</th><th>Payment</th><th>Amount</th><th>Teknulugy Profit</th><th>Net to Store</th></tr></thead><tbody>'+rows+'</tbody><tfoot><tr class="total-row"><td colspan="5">TOTAL</td><td>KWD '+totalAmount.toFixed(3)+'</td><td style="color:#166534">KWD '+totalCommission.toFixed(3)+'</td><td>KWD '+totalNet.toFixed(3)+'</td></tr></tfoot></table><div class="footer">Teknulugy IT Services - Ahmed Al Jaber Street, Baitak Tower, Floor 1, Office D - +965 55107000</div></body></html>');
  win.document.close();
  setTimeout(()=>win.print(),500);
}
const EMPTY_STORE = { store_name:'', percentage:'', payment_method:'Both', notes:'' };
const EMPTY_TXN   = { store_id:'', order_id:'', merchant_id:'', amount:'', payment_method:'Deema', transaction_date:'', notes:'', transfer_status:false };

export default function TakhierPage() {
  const qc = useQueryClient();
  const [tab, setTab]               = useState('transactions');
  const [storeFilter, setStoreFilter] = useState('');
  const [showStoreForm, setShowStoreForm] = useState(false);
  const [editStore, setEditStore]   = useState(null);
  const [storeForm, setStoreForm]   = useState(EMPTY_STORE);
  const [showTxnForm, setShowTxnForm] = useState(false);
  const [txnForm, setTxnForm]       = useState(EMPTY_TXN);
  const [proofFile, setProofFile]   = useState(null);
  const [editTxn, setEditTxn]         = useState(null);
  const setS = (k,v) => setStoreForm(p=>({...p,[k]:v}));
  const setT = (k,v) => setTxnForm(p=>({...p,[k]:v}));

  const { data:storesData } = useQuery({ queryKey:['takhier-stores'], queryFn:()=>api.get('/takhier/stores').then(r=>r.data) });
  const { data:txnsData, isLoading } = useQuery({
    queryKey:['takhier-txns', storeFilter],
    queryFn:()=>api.get('/takhier/transactions',{params:{store_id:storeFilter||undefined}}).then(r=>r.data),
  });

  const createStoreMut = useMutation({
    mutationFn: ()=>api.post('/takhier/stores', storeForm),
    onSuccess:()=>{ qc.invalidateQueries(['takhier-stores']); setShowStoreForm(false); setStoreForm(EMPTY_STORE); toast.success('Store added!'); },
    onError: e=>toast.error(e.response?.data?.message||'Error'),
  });
  const updateStoreMut = useMutation({
    mutationFn: ()=>api.put('/takhier/stores/'+editStore.id, storeForm),
    onSuccess:()=>{ qc.invalidateQueries(['takhier-stores']); setEditStore(null); toast.success('Updated!'); },
  });
  const deleteStoreMut = useMutation({
    mutationFn: id=>api.delete('/takhier/stores/'+id),
    onSuccess:()=>{ qc.invalidateQueries(['takhier-stores']); toast.success('Store removed'); },
  });

  const readFile = file => new Promise(resolve => {
    const r = new FileReader(); r.onload = e => resolve(e.target.result); r.readAsDataURL(file);
  });

  const createTxnMut = useMutation({
    mutationFn: async () => {
      const payload = {...txnForm};
      if (proofFile) { payload.proof_file = await readFile(proofFile); payload.proof_filename = proofFile.name; }
      return api.post('/takhier/transactions', payload);
    },
    onSuccess:()=>{ qc.invalidateQueries(['takhier-txns']); setShowTxnForm(false); setTxnForm(EMPTY_TXN); setProofFile(null); toast.success('Transaction added!'); },
    onError: e=>toast.error(e.response?.data?.message||'Error'),
  });
  const updateTxnMut = useMutation({
    mutationFn: async ({id, data}) => {
      const payload = {...data};
      if (proofFile) { payload.proof_file = await readFile(proofFile); payload.proof_filename = proofFile.name; }
      return api.put('/takhier/transactions/'+id, payload);
    },
    onSuccess:()=>{ qc.invalidateQueries(['takhier-txns']); setEditTxn(null); setTxnForm(EMPTY_TXN); setProofFile(null); toast.success('Updated!'); },
  });
  const toggleTransferMut = useMutation({
    mutationFn: ({id, val})=>api.put('/takhier/transactions/'+id,{transfer_status:val}),
    onSuccess:()=>{ qc.invalidateQueries(['takhier-txns']); },
  });
  const deleteTxnMut = useMutation({
    mutationFn: id=>api.delete('/takhier/transactions/'+id),
    onSuccess:()=>{ qc.invalidateQueries(['takhier-txns']); toast.success('Deleted'); },
  });

  const downloadProof = async (id, name) => {
    try {
      const res = await api.get('/takhier/transactions/'+id+'/proof',{responseType:'blob'});
      const url = URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a'); a.href=url; a.download=name; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error('File not found'); }
  };

  const stores = storesData?.data || [];
  const txns   = txnsData?.data   || [];

  const totalAmount    = txns.reduce((s,t)=>s+parseFloat(t.amount||0),0);
  const totalCommission = txns.reduce((s,t)=>s+parseFloat(t.commission||0),0);
  const totalNet       = txns.reduce((s,t)=>s+parseFloat(t.net_profit||0),0);
  const pendingNet     = txns.filter(t=>!t.transfer_status).reduce((s,t)=>s+parseFloat(t.net_profit||0),0);
  const transferredNet = txns.filter(t=>t.transfer_status).reduce((s,t)=>s+parseFloat(t.net_profit||0),0);

  // Per store pending calculation
  const storeStats = stores.map(s => {
    const storeTxns = txns.filter(t=>String(t.store_id)===String(s.id));
    const pending   = storeTxns.filter(t=>!t.transfer_status).reduce((a,t)=>a+parseFloat(t.net_profit||0),0);
    const transferred = storeTxns.filter(t=>t.transfer_status).reduce((a,t)=>a+parseFloat(t.net_profit||0),0);
    const total     = storeTxns.reduce((a,t)=>a+parseFloat(t.net_profit||0),0);
    return { ...s, pending, transferred, total, txnCount: storeTxns.length };
  });

  // preview calc
  const selectedStore  = stores.find(s=>String(s.id)===String(txnForm.store_id));
  const previewAmount  = parseFloat(txnForm.amount||0);
  const previewPct     = selectedStore ? parseFloat(selectedStore.percentage) : 0;
  const previewComm    = parseFloat((previewAmount * previewPct / 100).toFixed(3));
  const previewNet     = parseFloat((previewAmount - previewComm).toFixed(3));

  const openEditStore = s => {
    setEditStore(s);
    setStoreForm({ store_name:s.store_name, percentage:s.percentage, payment_method:s.payment_method, notes:s.notes||'' });
    setShowStoreForm(false);
  };

  const openEditTxn = t => {
    setEditTxn(t);
    setTxnForm({ store_id:t.store_id, order_id:t.order_id||'', merchant_id:t.merchant_id||'', amount:t.amount, payment_method:t.payment_method, transaction_date:t.transaction_date, notes:t.notes||'', transfer_status:t.transfer_status||false });
    setProofFile(null);
    setShowTxnForm(false);
  };

  return (
    <PasswordGate moduleName="takhier" moduleLabel="Takhier">
    <div>
      {/* Stats */}
      <div className="g4" style={{marginBottom:12}}>
        <div className="card-sm"><div className="stat-label">Total Stores</div><div className="stat-val">{stores.length}</div></div>
        <div className="card-sm"><div className="stat-label">Total Amount</div><div className="stat-val">KWD {totalAmount.toFixed(3)}</div></div>
        <div className="card-sm"><div className="stat-label">Teknulugy Profit</div><div className="stat-val" style={{color:'var(--green)'}}>KWD {totalCommission.toFixed(3)}</div></div>
        <div className="card-sm"><div className="stat-label">Net to Store</div><div className="stat-val" style={{color:'var(--muted)'}}>KWD {totalNet.toFixed(3)}</div></div>
      </div>
      <div className="g2" style={{marginBottom:20}}>
        <div className="card-sm" style={{borderLeft:'3px solid var(--warn)'}}>
          <div className="stat-label">Pending Transfer to Stores</div>
          <div className="stat-val" style={{color:'var(--warn)'}}>KWD {pendingNet.toFixed(3)}</div>
          <div style={{fontSize:11,color:'var(--muted)',marginTop:4}}>{txns.filter(t=>!t.transfer_status).length} transactions not yet transferred</div>
        </div>
        <div className="card-sm" style={{borderLeft:'3px solid var(--green)'}}>
          <div className="stat-label">Transferred to Stores</div>
          <div className="stat-val" style={{color:'var(--green)'}}>KWD {transferredNet.toFixed(3)}</div>
          <div style={{fontSize:11,color:'var(--muted)',marginTop:4}}>{txns.filter(t=>t.transfer_status).length} transactions transferred</div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',gap:8,marginBottom:16,alignItems:'center'}}>
        <div className="tab-bar">
          <button className={"tab-btn"+(tab==='transactions'?" active":"")} onClick={()=>setTab('transactions')}>Transactions</button>
          <button className={"tab-btn"+(tab==='stores'?" active":"")} onClick={()=>setTab('stores')}>Stores</button>
        </div>

        {tab==='transactions' && (
          <>
            <select className="form-select" style={{width:180}} value={storeFilter} onChange={e=>setStoreFilter(e.target.value)}>
              <option value="">All Stores</option>
              {stores.map(s=><option key={s.id} value={s.id}>{s.store_name}</option>)}
            </select>
            {storeFilter && <button className="btn btn-outline btn-sm" onClick={()=>setStoreFilter('')}>Clear</button>}
            <div style={{marginLeft:'auto',display:'flex',gap:8}}>
              <button className="btn btn-outline" onClick={()=>printTransactions(txns,totalAmount,totalCommission,totalNet)} style={{display:'flex',alignItems:'center',gap:6}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
                Print
              </button>
              <button className="btn btn-primary" onClick={()=>{setShowTxnForm(v=>!v);}}>+ Add Transaction</button>
            </div>
          </>
        )}
        {tab==='stores' && (
          <div style={{marginLeft:'auto',display:'flex',gap:8}}>
            <button className="btn btn-outline" onClick={()=>printStores(stores)} style={{display:'flex',alignItems:'center',gap:6}}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
              Print Stores
            </button>
            <button className="btn btn-primary" onClick={()=>{setShowStoreForm(v=>!v);setEditStore(null);setStoreForm(EMPTY_STORE);}}>+ Add Store</button>
          </div>
        )}
      </div>

      {/* STORES TAB */}
      {tab==='stores' && (
        <>
          {(showStoreForm||editStore) && (
            <div className="card" style={{marginBottom:16}}>
              <div className="form-section-title">{editStore?'Edit Store':'New Store'}</div>
              <div className="form-grid">
                <div className="form-group"><label className="form-label">Store Name *</label>
                  <input className="form-input" value={storeForm.store_name} onChange={e=>setS('store_name',e.target.value)} placeholder="Store name"/></div>
                <div className="form-group"><label className="form-label">Commission % *</label>
                  <input className="form-input" type="number" min="0" max="100" step="0.01" value={storeForm.percentage} onChange={e=>setS('percentage',e.target.value)} placeholder="e.g. 15"/></div>
                <div className="form-group"><label className="form-label">Payment Method</label>
                  <select className="form-select" value={storeForm.payment_method} onChange={e=>setS('payment_method',e.target.value)}>
                    <option value="Deema">Deema</option>
                    <option value="Taly">Taly</option>
                    <option value="Both">Both (Deema & Taly)</option>
                  </select></div>
                <div className="form-group"><label className="form-label">Notes</label>
                  <input className="form-input" value={storeForm.notes} onChange={e=>setS('notes',e.target.value)} placeholder="Notes..."/></div>
              </div>
              <div style={{display:'flex',gap:8,marginTop:8}}>
                <button className="btn btn-primary" onClick={()=>editStore?updateStoreMut.mutate():createStoreMut.mutate()}>Save Store</button>
                <button className="btn btn-outline" onClick={()=>{setShowStoreForm(false);setEditStore(null);}}>Cancel</button>
              </div>
            </div>
          )}

          <div className="card">
            <table className="tbl">
              <thead><tr><th>Store Name</th><th>Commission %</th><th>Payment Method</th><th>Notes</th><th>Actions</th></tr></thead>
              <tbody>
                {stores.length===0&&<tr><td colSpan={5} className="empty-state">No stores added yet</td></tr>}
                {stores.map(s=>(
                  <tr key={s.id}>
                    <td style={{fontWeight:700}}>{s.store_name}</td>
                    <td><span className="badge badge-warn" style={{fontSize:13}}>{parseFloat(s.percentage).toFixed(1)}%</span></td>
                    <td><span className={"badge "+(s.payment_method==='Both'?'badge-purple':s.payment_method==='Deema'?'badge-info':'badge-green')}>{s.payment_method}</span></td>
                    <td style={{color:'var(--muted)',fontSize:12}}>{s.notes||'--'}</td>
                    <td><div style={{display:'flex',gap:6}}>
                      <button className="btn btn-outline btn-sm" onClick={()=>openEditStore(s)}>Edit</button>
                      <button className="btn btn-danger btn-sm" onClick={()=>{if(window.confirm('Remove store?'))deleteStoreMut.mutate(s.id);}}>X</button>
                    </div></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* TRANSACTIONS TAB */}
      {tab==='transactions' && (
        <>
          {showTxnForm && (
            <div className="card" style={{marginBottom:16}}>
              <div className="form-section-title">{editTxn ? 'Edit Transaction' : 'New Transaction'}</div>
              <div className="form-grid">
                <div className="form-group"><label className="form-label">Store *</label>
                  <select className="form-select" value={txnForm.store_id} onChange={e=>setT('store_id',e.target.value)}>
                    <option value="">Select store...</option>
                    {stores.map(s=><option key={s.id} value={s.id}>{s.store_name} ({parseFloat(s.percentage).toFixed(1)}%)</option>)}
                  </select></div>
                <div className="form-group"><label className="form-label">Payment Method *</label>
                  <select className="form-select" value={txnForm.payment_method} onChange={e=>setT('payment_method',e.target.value)}>
                    {PM.map(p=><option key={p}>{p}</option>)}
                  </select></div>
                <div className="form-group"><label className="form-label">Order ID</label>
                  <input className="form-input" value={txnForm.order_id} onChange={e=>setT('order_id',e.target.value)} placeholder="Order ID"/></div>
                <div className="form-group"><label className="form-label">Merchant ID</label>
                  <input className="form-input" value={txnForm.merchant_id} onChange={e=>setT('merchant_id',e.target.value)} placeholder="Merchant ID"/></div>
                <div className="form-group"><label className="form-label">Amount (KWD) *</label>
                  <input className="form-input" type="number" min="0" step="0.001" value={txnForm.amount} onChange={e=>setT('amount',e.target.value)} placeholder="0.000"/></div>
                <div className="form-group"><label className="form-label">Transaction Date *</label>
                  <input className="form-input" type="date" value={txnForm.transaction_date} onChange={e=>setT('transaction_date',e.target.value)}/></div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label className="form-label">Upload Proof of Transfer</label>
                  <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e=>{ setProofFile(e.target.files[0]); setT('transfer_status', true); }}
                    style={{padding:'8px 12px',background:'#fff',border:'1.5px solid var(--border)',borderRadius:8,color:'var(--text)',width:'100%',fontSize:13}}/>
                  {proofFile&&<div style={{fontSize:11,color:'var(--green)',marginTop:4}}>Selected: {proofFile.name}</div>}
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label className="form-label">Notes</label>
                  <input className="form-input" value={txnForm.notes} onChange={e=>setT('notes',e.target.value)} placeholder="Notes..."/></div>
              </div>

              {/* Live Preview */}
              {txnForm.store_id && txnForm.amount > 0 && (
                <div style={{background:'linear-gradient(135deg,#f0fdf7,#e8f8f1)',border:'1.5px solid #86efac',borderRadius:12,padding:16,margin:'16px 0'}}>
                  <div style={{fontSize:11,fontWeight:700,color:'var(--green)',textTransform:'uppercase',letterSpacing:'.5px',marginBottom:12}}>Live Calculation Preview</div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12}}>
                    <div style={{background:'#fff',borderRadius:8,padding:12,textAlign:'center'}}>
                      <div style={{fontSize:11,color:'var(--muted)',marginBottom:4}}>Total Amount</div>
                      <div style={{fontSize:18,fontWeight:700}}>KWD {previewAmount.toFixed(3)}</div>
                    </div>
                    <div style={{background:'#fff',borderRadius:8,padding:12,textAlign:'center'}}>
                      <div style={{fontSize:11,color:'var(--muted)',marginBottom:4}}>Commission ({previewPct}%)</div>
                      <div style={{fontSize:18,fontWeight:700,color:'var(--danger)'}}>- KWD {previewComm.toFixed(3)}</div>
                    </div>
                    <div style={{background:'var(--green)',borderRadius:8,padding:12,textAlign:'center'}}>
                      <div style={{fontSize:11,color:'rgba(255,255,255,0.8)',marginBottom:4}}>Your Net Profit</div>
                      <div style={{fontSize:18,fontWeight:700,color:'#fff'}}>KWD {previewNet.toFixed(3)}</div>
                    </div>
                  </div>
                </div>
              )}

              <div style={{display:'flex',gap:8}}>
                <button className="btn btn-primary" onClick={()=>editTxn?updateTxnMut.mutate({id:editTxn.id,data:txnForm}):createTxnMut.mutate()}>
                  {editTxn?'Update Transaction':'Save Transaction'}
                </button>
                <button className="btn btn-outline" onClick={()=>{setShowTxnForm(false);setEditTxn(null);setTxnForm(EMPTY_TXN);setProofFile(null);}}>Cancel</button>
              </div>
            </div>
          )}

          <div className="card">
            {isLoading?<div className="loading-center"><div className="spinner"/></div>:(
              <>
                <table className="tbl">
                  <thead>
                    <tr><th>Date</th><th>Store</th><th>Order ID</th><th>Merchant ID</th><th>Payment</th><th>Amount</th><th>Teknulugy Profit</th><th>Net to Store</th><th>Transferred</th><th>Proof</th><th>Actions</th></tr>
                  </thead>
                  <tbody>
                    {txns.length===0&&<tr><td colSpan={10} className="empty-state">No transactions found</td></tr>}
                    {txns.map(t=>(
                      <tr key={t.id}>
                        <td style={{color:'var(--muted)',fontSize:12}}>{t.transaction_date}</td>
                        <td style={{fontWeight:600}}>{t.store?.store_name||'--'}</td>
                        <td style={{fontFamily:'monospace',fontSize:12,color:'var(--muted)'}}>{t.order_id||'--'}</td>
                        <td style={{fontFamily:'monospace',fontSize:12,color:'var(--muted)'}}>{t.merchant_id||'--'}</td>
                        <td><span className={"badge "+(t.payment_method==='Deema'?'badge-info':'badge-green')}>{t.payment_method}</span></td>
                        <td style={{fontWeight:600}}>KWD {parseFloat(t.amount).toFixed(3)}</td>
                        <td style={{color:'var(--green)',fontWeight:700}}>KWD {parseFloat(t.commission).toFixed(3)} <span style={{fontSize:10,color:'var(--muted)'}}>({parseFloat(t.percentage).toFixed(1)}%)</span></td>
                        <td style={{color:'var(--muted)',fontWeight:600}}>KWD {parseFloat(t.net_profit).toFixed(3)}</td>
                        <td style={{textAlign:'center'}}>
                          <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:6}}>
                            <input type="checkbox" checked={t.transfer_status||false}
                              onChange={e=>toggleTransferMut.mutate({id:t.id,val:e.target.checked})}
                              style={{width:18,height:18,accentColor:'var(--green)',cursor:'pointer'}}/>
                            <span style={{fontSize:11,color:t.transfer_status?'var(--green)':'var(--muted)',fontWeight:600}}>
                              {t.transfer_status?'Done':'Pending'}
                            </span>
                          </div>
                        </td>
                        <td>{t.proof_name
                          ?<button className="btn btn-outline btn-sm" style={{color:'var(--green)',borderColor:'var(--green)'}} onClick={()=>downloadProof(t.id,t.proof_name)}>Download</button>
                          :<span style={{color:'#ccc',fontSize:12}}>--</span>}
                        </td>
                        <td><div style={{display:'flex',gap:6}}>
                          <button className="btn btn-outline btn-sm" onClick={()=>{openEditTxn(t);setShowTxnForm(true);}}>Edit</button>
                          <button className="btn btn-danger btn-sm" onClick={()=>{if(window.confirm('Delete?'))deleteTxnMut.mutate(t.id);}}>X</button>
                        </div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {txns.length>0&&(
                  <div style={{display:'flex',justifyContent:'flex-end',gap:24,padding:'16px 0 0',borderTop:'1px solid var(--border)',marginTop:8}}>
                    <div style={{fontSize:13}}><span style={{color:'var(--muted)'}}>Total Amount: </span><strong>KWD {totalAmount.toFixed(3)}</strong></div>
                    <div style={{fontSize:13}}><span style={{color:'var(--muted)'}}>Teknulugy Profit: </span><strong style={{color:'var(--green)'}}>KWD {totalCommission.toFixed(3)}</strong></div>
                    <div style={{fontSize:13}}><span style={{color:'var(--muted)'}}>Net to Store: </span><strong style={{color:'var(--muted)'}}>KWD {totalNet.toFixed(3)}</strong></div>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
    </PasswordGate>
  );
}
